import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selector: String }

  toggle(event) {
    const form = this.element.closest("form")
    const checkboxes = Array.from(form.querySelectorAll(this.selectorValue))
    const checked = event.target.checked

    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked
      checkbox.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
  connect() {
    this.element.addEventListener("change", this.toggle.bind(this))
  }
  disconnect() {
    this.element.removeEventListener("change", this.toggle.bind(this))
  }
}
